import { grey700, text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { fontH2, fontRegular } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing(6)};

  .PricingPageHero-branding {
    letter-spacing: 2px;
    text-transform: uppercase;
    max-width: 320px;
    width: 320px;
    padding-bottom: ${spacing(6)};
    border-bottom: 1px solid ${grey700 + '26'}; // 15% opaque
  }

  .PricingPageHero-headingGroup {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }

  .PricingPageHero-heading {
    ${fontH2};
    text-align: center;
  }

  .PricingPageHero-copy {
    ${fontRegular};
    color: ${text_colorTextSecondary};
    text-align: center;
    max-width: 666px;
  }
`
